export default "<p>bookstore works!</p>\n"